module.exports = __webpack_public_path__ + "img/ic-pin.a6f05aba.svg";